// extracted by mini-css-extract-plugin
export default {"title":"LaX3URy7aexHtUVfD1yX7A==","grid":"eYKC8VwWzOEsD8UCYckGtQ==","block":"T-z+ONUScpqAIodpOwpHKw==","filename":"mJlxwjK2QTs5At9K7Ktxqg==","downloadBtn":"Xek00QqmaAo2tj9GaszmYQ=="};